import { Option, useFormApi, useFormState } from "informed";
import * as React from "react";
import { nameof } from "ts-simple-nameof";
import { Site, Subject, DeviceType } from "webportalclient";
import { DeviceTypes } from "../../misc/api/apiTypes";
import { MultiSelect } from "../../forms/informedv2/MultiSelect";
import { Required } from "../../forms/validation/Required";
import { Package } from "@vitalograph/update-client";

export interface DevicesFormModel {
    deviceType: DeviceType;
    serialNumber: any;
    allocatedSite: Site;
    allocatedSubject: Subject;
    spirotracPackageVersion: Package
}

export interface DeviceFormProps {
    editMode: boolean;
    clientDevices: any[];
    sites: Site[];
    subjects: Subject[];
    deviceTypes: DeviceType[];
    spirotracPackages: Package[]
}

export interface FormattedPackage extends Package {
    displayValue: string
}
export const DeviceForm = ({ editMode, clientDevices, sites, subjects, deviceTypes, spirotracPackages }: DeviceFormProps) => {
    const formApi = useFormApi<DevicesFormModel>();
    const formState = useFormState<DevicesFormModel>();
    const packageOptions = spirotracPackages.map(p=>{
        const formatted = p as FormattedPackage;
        formatted.displayValue = p.name + "." + p.version;
        return formatted;
    })
    return (
        <div className="row">
            <div className="col-md-12">
                <div id="devicesFormPanel" className="panel panel-primary">
                    <div className="panel-body">
                        <div className="row">
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="SerialNumber">Serial Number</label>
                                <MultiSelect
                                    disabled={!clientDevices.length || editMode}
                                    id="SerialNumber"
                                    field={nameof<DevicesFormModel>(f => f.serialNumber)}
                                    options={clientDevices}
                                    validate={Required}
                                    labelKey="serial"
                                    valueKey="id"
                                    multi={false}
                                />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="DeviceType">Device Type</label>
                                <MultiSelect
                                    disabled={!deviceTypes.length}
                                    id="DeviceType"
                                    field={nameof<DevicesFormModel>(f => f.deviceType)}
                                    validate={Required}
                                    options={deviceTypes}
                                    labelKey="name"
                                    valueKey="id"
                                    multi={false}
                                    onChange={() => {
                                        if (formApi.getValue(nameof<DevicesFormModel>(f => f.allocatedSite)))
                                            formApi.setValue(nameof<DevicesFormModel>(f => f.allocatedSite), null)

                                        if (formApi.getValue(nameof<DevicesFormModel>(f => f.allocatedSubject)))
                                            formApi.setValue(nameof<DevicesFormModel>(f => f.allocatedSubject), null)
                                    }}
                                />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="AllocatedSite">Allocated Site</label>
                                <MultiSelect
                                    disabled={!sites.length || !formState.values.deviceType || formState.values.deviceType?.id !== DeviceTypes.Spirotrac6}
                                    id="AllocatedSite"
                                    field={nameof<DevicesFormModel>(f => f.allocatedSite)}
                                    options={sites}
                                    labelKey="number"
                                    valueKey="id"
                                    multi={false}
                                />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="AllocatedSubject">Allocated Subject</label>
                                <MultiSelect
                                    disabled={!subjects.length || !formState.values.deviceType || formState.values.deviceType?.id === DeviceTypes.Spirotrac6}
                                    id="AllocatedSubject"
                                    field={nameof<DevicesFormModel>(f => f.allocatedSubject)}
                                    options={subjects}
                                    labelKey="number"
                                    valueKey="id"
                                    multi={false}
                                />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="spirotracPackageVersion">Package Version</label>
                                <MultiSelect
                                    disabled={!spirotracPackages.length || !formState.values.deviceType || formState.values.deviceType?.id != DeviceTypes.Spirotrac6}
                                    id="spirotracPackageVersion"
                                    field={nameof<DevicesFormModel>(f => f.spirotracPackageVersion)}
                                    options={packageOptions}
                                    labelKey="displayValue"
                                    valueKey="version"
                                    multi={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}
